export * from './baseStyles'

export const APP_URL = 'https://setter.app.link/akAHuIWZ5Q'
export const BASE_URL = 'https://setter.netlify.com'
export const CAREER_URL = 'https://jobs.lever.co/setter'
